import type { Ref } from "vue";
import type { Requests } from "../common/request.common";
import type { RadiusNASResponseTypes } from "../common/response.common";
import { asRemoveHook, asUpdateHook, get, post, postEmpty } from "./common";

export const radiusNAS = {
    record(data: typeof Requests.RadiusNAS.Record.Input) {
        return post<typeof data, RadiusNASResponseTypes.Record>(`/radius-nas/record`, data);
    },
    create(data: typeof Requests.RadiusNAS.Create.Input) {
        return post<typeof data>("/radius-nas/create", data);
    },
    obtain(id: string) {
        return get<RadiusNASResponseTypes.Obtain>(`/radius-nas/obtain/${id}`);
    },
    delete(id: string) {
        return postEmpty(`/radius-nas/delete/${id}`);
    },
    formHooks: {
        update(id: string, isLoading?: Ref<boolean>) {
            return async (data: typeof Requests.RadiusNAS.Update.Input) => {
                return await asUpdateHook(
                    post<typeof data>(`/radius-nas/update/${id}`, data),
                    isLoading,
                );
            };
        },
        remove(id: string, isLoading?: Ref<boolean>) {
            return async (data: typeof Requests.RadiusNAS.Remove.Input) => {
                return await asRemoveHook(
                    post<typeof data>(`/radius-nas/remove/${id}`, data),
                    isLoading,
                );
            };
        },
    },
};
